import { Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Video } from '../../models/video';
import { VideosService } from '../../services/videos.service';
import { PlaylistService } from '../../services/playlist.service';
import { VideoComponent } from '../video/video.component';
import { Playlist } from '../../models/playlist';



@Component({
  selector: 'app-videos',
  imports: [VideoComponent],
  templateUrl: './videos.component.html',
  styleUrl: './videos.component.css',
})
export class VideosComponent {
  
  videos: WritableSignal<Video[]>  = signal([]);
  playlist: WritableSignal<Playlist | null>  = signal(null);

  private videosService = inject(VideosService);
  private playlistService = inject(PlaylistService);


  constructor(private route: ActivatedRoute) { }

  ngOnInit(){
    const id = this.route.snapshot.queryParams['id'];

    if(id){
      this.getPlaylist(id);
      this.getVideos(id);
    }

  }

  getVideos(id : string){
    this.videosService.getVideos(id).subscribe({
      next: (videos: Video[]) => {
        this.videos.set(videos);
        console.log('Videos fetched successfully:', this.videos.length);
      },
      error: (error: any) => {
        console.error('Failed to fetch videos:', error);
      }
    });
  }

  
  getPlaylist(id : string){
    this.playlistService.getPlaylist(id).subscribe({
      next: (playlist: Playlist) => {
        this.playlist.set(playlist);
        console.log('Playlist fetched successfully:', this.playlist);
      },
      error: (error: any) => {
        console.error('Failed to fetch playlist:', error);
      }
    });
  }
}
